import { WIDGET } from '@voltmoney/schema';
import { Accordion, AmountCard, Avatar, BottomSheet, BottomTab, Button, CalendarPicker, CameraPicker, Card, Carousal, ChatCard, Chip, CommentCard, CtaCard, DiscussionCard, Divider, DocumentPicker, DropdownInput, FeedCard, GoogleButton, Gradient, Grid, GridItem, Header, IcebreakerCard, Icon, Image, Info, LimitCard, LineItemCard, LinkPreview, List, ListItem, Lottie, MemberCard, Message, NewsCard, ProgressIndicator, PromoCard, Radio, Repayment, SelectiveListItem, ShimmerIcon, Slider, Space, Stack, Stepper, SuggestionCard, Tabs, Tag, TermsText, TextInput, Typography, UserCard, VerificationCard, WebView, RenderWidgetGroup, Table, DigioMobileIntegration, PromotionCard, RewardStructure, PartnerSignUpReferrer, PartnerBenefitCard, VoltPartnerCard, SelectionComponent, CitySelection, BankSelect, BankAddPage, ScrollStack, PartnerDetailCard, AssetSearchComponent, FilterChip, AutoPayPage, PartnerCheckLimitCard, TransactionPage, TransactionPageRevamp, AppBottomNav, EmailStatementPage, KycPage, CoBorrowerKycPage, DigioCBIntegration, CheckCustomerPortfolioPage, DigioAgreementSignPage, CreditLoading, ApplicationPendingBlockedPage, KfsPage, NameMismatch, LlaBenefitCard, RenderDigioCard, CustomHeader, KycDigioMandate, BorrowerLandingScreen, BajajKycDigioModal, Logout, SupportingDocumentPage, UploadFile, PhotoMismatchPage, RepaymentPage, UpiInProgress, StateSelectionPage, FailurePage, ManageLimitPage, ViewPortfolioPage, UnpledgePorfolioPage, PendingUnpledgeView, UnpledgeStatus, LoanForeclosure, OutstandingDues, PendingForeclosure, CoBorrowerKycVerificationPage, CoBorrowerKycSummaryPage, CollateralIntroCard, PresentationMaterial, CollateralDownloadInfoScreen, PreviewCollateralScreen, KycCard, PledgeScreen, CollateralLanguageFilter, PaymentNotApproved, KycSummary, OtpModalScreen, UserContext500, KycPhotoInit, AgreementInit, AgreementPolling, RewardWinterComponent, PanViewCard, EmailSubtitle, BajajAgreementStepper, BajajKFS, BottomBar, LoanRenewalDashboardCard, LoanRenewalLearnMorePage, ManageLimitLanding, ElevateLanding, ElevateSwitching, VerifyInterestEnhanceLimit, PreDashboardScreen, LoanRenewalLandingPage, LoanRenewalVerifySummaryPage, EnhanceLimitCard, LoanRenewalStatusScreen, WithdrawAmount, ConfirmAmount, RequestWithdraw, InterestRepaymentCard, InterestRepaymentDetails, InterestRepaymentLearnMore, LoanRenewalExpiredDashboardCard, RepaymentChargesDetailPages, DemoVideos, paymentSuccessFullScreen, FailureNote, RmContactList, TrackForeClosureRequest, BottomSheetMf, FetchPortfolioModals, CgtcInitPage, CgtcOtpPage, CgtcInProgressPage, CgtcSummaryPage, RemovePledgeSteps, PledgeHistory, PledgeDetails, CgtcNoPortfolio, ShortfallCard, ShortfallDetails, ShortfallInfo, ShortfallRepay, ShortfallRecomendedRepay, PhonePayPage, CreditLoadingDownload, KycDirect, ASESDocumentsListing, ASESIndividualDocument, ASESDocumentsUnderReview, ASESDocumentsRejected, ASESViewSampleDocument, PartnerPromotionCards, PhoneNumberPage, OtpVerifypage, EmailVerifyScreen, EnterEmailPage, KycPanVerificationPage, ManageLoanDetails, PartnerDropDownInput, PayoutDashboardPage, PayoutDetailPage, PartnerInterestCalculator, InterestCalculatorApp, InterestCalculatorCard, CustomerDetailsTable, InterestFilter, CustomerViewDetails, CustomerFilter, RenewalFilter, ShortfallFilter, CustomerMobDashboard, PartnerRegisterLeads, PartnerLeadsRegistrationSuccess, PLJJourneyPage, WithdrawalFailedCard, VerifyAndInterest, PendingApplicationScreen, PendingApplicationMobileScreen, PendingCustomerViewDetailsScreen, SDKProcessCompleteCard, AboutUsScreen, LendingPartnerScreen, ProductDetailsScreen, DspPaymentScreen, DspKfsPage, ContactUsPage, RepaymentBankTransfer, FAQSectionPage, AccountDetailsPage, MyLoanProfile, UpdateLoginScreen, UpdateEmailScreen, UpdateDetailsScreen, MFCentralEvaluateFundsPage, MFCentralFetchLandingPage, MFCFetchAnchorPage, RecommendedAssetRepository, ConfirmAndPayment, FlexiRepayScreen, MfdShareLinkInitPage, ForeClosureScreen, ForeclosureReasonPage, ConfirmLoanDetails, ForeclosureCollateralDetails, ForeclosureStatusPage, MyProfile, ElevateContinueCard, ElevateHomeCard, ElevateHeader, HelpAndSupport, FaqScreen, FaqDetails, } from './index';
// @ts-ignore
const registry = {
    [WIDGET.TEXT]: Typography,
    [WIDGET.INPUT]: TextInput,
    [WIDGET.BUTTON]: Button,
    [WIDGET.STACK]: Stack,
    [WIDGET.SPACE]: Space,
    [WIDGET.ICON]: Icon,
    [WIDGET.AVATAR]: Avatar,
    [WIDGET.TABS]: Tabs,
    [WIDGET.DIVIDER]: Divider,
    [WIDGET.CARD]: Card,
    [WIDGET.CHATCARD]: ChatCard,
    [WIDGET.IMAGE]: Image,
    [WIDGET.LINKPREVIEW]: LinkPreview,
    [WIDGET.PROGRESSINDICATOR]: ProgressIndicator,
    [WIDGET.LOTTIE]: Lottie,
    [WIDGET.GRADIENT]: Gradient,
    [WIDGET.CHIP]: Chip,
    [WIDGET.TAG]: Tag,
    [WIDGET.MEMBERCARD]: MemberCard,
    [WIDGET.ICEBREAKERCARD]: IcebreakerCard,
    [WIDGET.USERCARD]: UserCard,
    [WIDGET.NEWSCARD]: NewsCard,
    [WIDGET.DISCUSSIONCARD]: DiscussionCard,
    [WIDGET.FEEDCARD]: FeedCard,
    [WIDGET.COMMENTCARD]: CommentCard,
    [WIDGET.GRID]: Grid,
    [WIDGET.RADIO]: Radio,
    [WIDGET.LIST_ITEM]: ListItem,
    [WIDGET.SELECTIVE_LIST_ITEM]: SelectiveListItem,
    [WIDGET.STEPPER]: Stepper,
    [WIDGET.VERIFICATIONCARD]: VerificationCard,
    [WIDGET.GRIDITEM]: GridItem,
    [WIDGET.HEADER]: Header,
    [WIDGET.LIST]: List,
    [WIDGET.CTACARD]: CtaCard,
    [WIDGET.INFO]: Info,
    [WIDGET.CAMERA]: CameraPicker,
    [WIDGET.GOOGLE_BUTTON]: GoogleButton,
    [WIDGET.LINEITEMCARD]: LineItemCard,
    [WIDGET.AMOUNTCARD]: AmountCard,
    [WIDGET.PROMOCARD]: PromoCard,
    [WIDGET.REPAYMENT]: Repayment,
    [WIDGET.MESSAGE]: Message,
    [WIDGET.BOTTOMTAB]: BottomTab,
    [WIDGET.TERMS_TEXT]: TermsText,
    [WIDGET.WEB_VIEW]: WebView,
    [WIDGET.SHIMMERICON]: ShimmerIcon,
    [WIDGET.ACCORDION]: Accordion,
    [WIDGET.CAROUSAL]: Carousal,
    [WIDGET.CALENDAR_PICKER]: CalendarPicker,
    [WIDGET.DROPDOWN_INPUT]: DropdownInput,
    [WIDGET.DOCUMENT_PICKER]: DocumentPicker,
    [WIDGET.SUGGESTION_CARD]: SuggestionCard,
    [WIDGET.SLIDER]: Slider,
    [WIDGET.BOTTOMSHEET]: BottomSheet,
    [WIDGET.LIMIT_CARD]: LimitCard,
    [WIDGET.RENDER_WIDGET_GROUP]: RenderWidgetGroup,
    [WIDGET.TABLE]: Table,
    [WIDGET.KYC_DIGIO_MOBILE]: DigioMobileIntegration,
    [WIDGET.PROMOTION_CARD]: PromotionCard,
    [WIDGET.REWARD_STRUCTURE]: RewardStructure,
    [WIDGET.PARTNER_SIGNUP_REFERRER]: PartnerSignUpReferrer,
    [WIDGET.PARTNER_BENEFIT]: PartnerBenefitCard,
    [WIDGET.BANK_SELECT_PAGE]: BankSelect,
    [WIDGET.VOLT_PARTNERS]: VoltPartnerCard,
    [WIDGET.SELECTION_COMPONENT]: SelectionComponent,
    [WIDGET.CITY_SELECTION_INPUT]: CitySelection,
    [WIDGET.BANK_ADD_PAGE]: BankAddPage,
    [WIDGET.SCROLL_STACK]: ScrollStack,
    [WIDGET.ASSET_SEARCH]: AssetSearchComponent,
    [WIDGET.PARTNER_DETAILS_CARD]: PartnerDetailCard,
    [WIDGET.FILTER_CHIP]: FilterChip,
    [WIDGET.AUTO_PAY_LANDING_PAGE]: AutoPayPage,
    [WIDGET.PARTNER_CHECK_LIMIT_DETAIL_CARD]: PartnerCheckLimitCard,
    [WIDGET.KYC_ADDITIONAL_DETAILS_PAGE]: KycPage,
    [WIDGET.CO_BORROWER_KYC_ADDITIONAL_DETAILS_PAGE]: CoBorrowerKycPage,
    [WIDGET.CO_BORROWER_KYC_SUMMARY_PAGE]: CoBorrowerKycSummaryPage,
    [WIDGET.TRANSACTION_PAGE]: TransactionPage,
    [WIDGET.TRANSACTION_PAGE_REVAMP]: TransactionPageRevamp,
    [WIDGET.APP_BOTTOM_NAV]: AppBottomNav,
    [WIDGET.EMAIL_STATEMENT_PAGE]: EmailStatementPage,
    [WIDGET.CO_BORROWER_DIGIO_MOBILE]: DigioCBIntegration,
    [WIDGET.PARTNER_CUSTOMER_PORTFOLIO_DETAILS]: CheckCustomerPortfolioPage,
    [WIDGET.APPLICATION_PENDING_BLOCKED_PAGE]: ApplicationPendingBlockedPage,
    [WIDGET.DIGIO_AGREEMENT_PAGE]: DigioAgreementSignPage,
    [WIDGET.KFS_PAGE]: KfsPage,
    [WIDGET.CREDIT_LOADING_SCREEN]: CreditLoading,
    [WIDGET.NAME_MISMATCH]: NameMismatch,
    [WIDGET.LLA_BENEFIT_CARD]: LlaBenefitCard,
    [WIDGET.CUSTOM_HEADER]: CustomHeader,
    [WIDGET.KYC_DIGIO_MANDATE]: KycDigioMandate,
    [WIDGET.BORROWER_LANDING_PAGE]: BorrowerLandingScreen,
    [WIDGET.BAJAJ_DIGIO_KYC_MODAL]: BajajKycDigioModal,
    [WIDGET.LOGOUT_SCREEN]: Logout,
    [WIDGET.KYC_DIGIO_CARD]: RenderDigioCard,
    [WIDGET.SUPPORTING_DOCUMENT_PAGE]: SupportingDocumentPage,
    [WIDGET.UPLOAD_FILE]: UploadFile,
    [WIDGET.PHOTO_MISMATCH]: PhotoMismatchPage,
    [WIDGET.REPAYMENT_PAGE]: RepaymentPage,
    [WIDGET.UPI_IN_PROGRESS]: UpiInProgress,
    [WIDGET.STATE_SELECTION_PAGE]: StateSelectionPage,
    [WIDGET.FAILURE_PAGE]: FailurePage,
    [WIDGET.CO_BORROWER_KYC_VERIFICATION]: CoBorrowerKycVerificationPage,
    [WIDGET.VIEW_PORTFOLIO]: ViewPortfolioPage,
    [WIDGET.MANAGE_LIMIT_PAGE]: ManageLimitPage,
    [WIDGET.UNPLEDGE_PORTFOLIO]: UnpledgePorfolioPage,
    [WIDGET.PENDING_UNPLEDGE_VIEW]: PendingUnpledgeView,
    [WIDGET.UNPLEDGE_STATUS]: UnpledgeStatus,
    [WIDGET.LOAN_FORECLOSURE]: LoanForeclosure,
    [WIDGET.OUTSTANDING_DUES]: OutstandingDues,
    [WIDGET.PENDING_FORECLOSURE]: PendingForeclosure,
    [WIDGET.COLLATERAL_INTRO_SCREEN]: CollateralIntroCard,
    [WIDGET.PRESENTATION_MATERIAL_SCREEN]: PresentationMaterial,
    [WIDGET.COLLATERAL_DOWNLOAD_INFO_SCREEN]: CollateralDownloadInfoScreen,
    [WIDGET.PREVIEW_COLLATERAL_SCREEN]: PreviewCollateralScreen,
    [WIDGET.KYC_CARD]: KycCard,
    [WIDGET.PLEDGE_SCREEN]: PledgeScreen,
    [WIDGET.COLLATERAL_LANGUAGE_FILTER_SELECT]: CollateralLanguageFilter,
    [WIDGET.USER_CONTEXT_500]: UserContext500,
    [WIDGET.PAYMENT_NOT_APPROVED]: PaymentNotApproved,
    [WIDGET.KYC_SUMMARY]: KycSummary,
    [WIDGET.OTP_MODAL_SCREEN]: OtpModalScreen,
    [WIDGET.KYC_PHOTO_INIT]: KycPhotoInit,
    [WIDGET.AGREEMENT_INIT]: AgreementInit,
    [WIDGET.AGREEMENT_POLLING]: AgreementPolling,
    [WIDGET.REWARD_STRUCTURE_WINTER]: RewardWinterComponent,
    [WIDGET.PAN_VIEW_CARD]: PanViewCard,
    [WIDGET.EMAIL_SUBTITLE]: EmailSubtitle,
    [WIDGET.BAJAJ_AGREEMENT_STEPPER]: BajajAgreementStepper,
    [WIDGET.BAJAJ_KFS]: BajajKFS,
    [WIDGET.BOTTOM_BAR]: BottomBar,
    [WIDGET.MANAGE_LIMIT_LANDING_PAGE]: ManageLimitLanding,
    [WIDGET.VERIFY_INTEREST_ENHANCE_LIMIT]: VerifyInterestEnhanceLimit,
    [WIDGET.PRE_DASHBOARD_SCREEN]: PreDashboardScreen,
    [WIDGET.ENHANCE_LIMIT_CARD]: EnhanceLimitCard,
    [WIDGET.LOAN_RENEWAL_DASHBOARD_CARD]: LoanRenewalDashboardCard,
    [WIDGET.LOAN_RENEWAL_LEARN_MORE_PAGE]: LoanRenewalLearnMorePage,
    [WIDGET.LOAN_RENEWAL_LANDING_PAGE]: LoanRenewalLandingPage,
    [WIDGET.LOAN_RENEWAL_VERIFY_SUMMARY_PAGE]: LoanRenewalVerifySummaryPage,
    [WIDGET.LOAN_RENEWAL_STATUS_PAGE]: LoanRenewalStatusScreen,
    [WIDGET.WITHDRAW_AMOUNT]: WithdrawAmount,
    [WIDGET.CONFIRM_AMOUNT]: ConfirmAmount,
    [WIDGET.REQUEST_WITHDRAW]: RequestWithdraw,
    [WIDGET.INTEREST_REPAYMENT_CARD]: InterestRepaymentCard,
    [WIDGET.LOAN_RENEWAL_EXPIRED_DASHBOARD_CARD]: LoanRenewalExpiredDashboardCard,
    [WIDGET.REPAYMENT_CHARGES_DETAILS_PAGE]: RepaymentChargesDetailPages,
    [WIDGET.DEMO_VIDEOS_LIST]: DemoVideos,
    [WIDGET.INTEREST_REPAYMENT_DETAILS]: InterestRepaymentDetails,
    [WIDGET.PAYMENT_SUCCESSFULL_SCREEN]: paymentSuccessFullScreen,
    [WIDGET.DSP_PAYMENT_SCREEN]: DspPaymentScreen,
    [WIDGET.FAILURE_NOTE]: FailureNote,
    [WIDGET.INTEREST_REPAYMENT_LEARN_MORE]: InterestRepaymentLearnMore,
    [WIDGET.RM_CONTACT_LIST]: RmContactList,
    [WIDGET.TRACK_FORECLOSURE_REQUEST]: TrackForeClosureRequest,
    [WIDGET.BOTTOM_SHEET_MF]: BottomSheetMf,
    [WIDGET.FETCH_PORTFOLIO_MODAL]: FetchPortfolioModals,
    [WIDGET.CGTC_INIT]: CgtcInitPage,
    [WIDGET.CGTC_OTP]: CgtcOtpPage,
    [WIDGET.CGTC_PROGRESS]: CgtcInProgressPage,
    [WIDGET.CGTC_SUMMARY]: CgtcSummaryPage,
    [WIDGET.CGTC_NO_PORTFOLIO]: CgtcNoPortfolio,
    [WIDGET.REMOVE_PLEDGE_STEPS]: RemovePledgeSteps,
    [WIDGET.PLEDGE_HISTORY]: PledgeHistory,
    [WIDGET.PLEDGE_DETAILS]: PledgeDetails,
    [WIDGET.SHORTFALL_CARD]: ShortfallCard,
    [WIDGET.SHORTFALL_DETAILS]: ShortfallDetails,
    [WIDGET.SHORTFALL_INFO]: ShortfallInfo,
    [WIDGET.SHORTFALL_REPAY]: ShortfallRepay,
    [WIDGET.SHORTFALL_RECOMENDED_REPAY]: ShortfallRecomendedRepay,
    [WIDGET.PHONE_PAY_PAGE]: PhonePayPage,
    [WIDGET.CREDIT_LIMIT_DOWNLOAD]: CreditLoadingDownload,
    [WIDGET.KYC_DIRECT]: KycDirect,
    [WIDGET.AS_ES_DOCUMENTS_LISTING]: ASESDocumentsListing,
    [WIDGET.PARTNER_DROP_DOWN_INPUT]: PartnerDropDownInput,
    [WIDGET.AS_ES_INDIVIDUAL_DOCUMENT]: ASESIndividualDocument,
    [WIDGET.AS_ES_DOCUMENT_UNDER_REVIEW]: ASESDocumentsUnderReview,
    [WIDGET.AS_ES_DOCUMENTS_REJECTED]: ASESDocumentsRejected,
    [WIDGET.AS_ES_VIEW_SAMPLE_DOCUMENT]: ASESViewSampleDocument,
    [WIDGET.PARTNER_PROMOTION_CARD]: PartnerPromotionCards,
    [WIDGET.PHONE_NUMBER_PAGE]: PhoneNumberPage,
    [WIDGET.OTP_VERIFY_PAGE]: OtpVerifypage,
    [WIDGET.EMAIL_VERIFY_PAGE]: EmailVerifyScreen,
    [WIDGET.ENTER_EMAIL_PAGE]: EnterEmailPage,
    [WIDGET.KYC_PAN_VERIFICATION_PAGE]: KycPanVerificationPage,
    [WIDGET.MANAGE_LOAN_DETAILS]: ManageLoanDetails,
    [WIDGET.PAYOUT_DASHBOARD_PAGE]: PayoutDashboardPage,
    [WIDGET.PAYOUT_DETAILS_PAGE]: PayoutDetailPage,
    [WIDGET.PARTNER_INTEREST_CALCULATOR]: PartnerInterestCalculator,
    [WIDGET.INTEREST_CALCULATOR_WIDGET_APP]: InterestCalculatorApp,
    [WIDGET.INTEREST_CALCULATOR_ENTRY_CARD]: InterestCalculatorCard,
    [WIDGET.CUSTOMER_DETAILS_TABLE]: CustomerDetailsTable,
    [WIDGET.INTEREST_FILTER_SCREEN_DC]: InterestFilter,
    [WIDGET.CUSTOMER_FILTER_SCREEN_DC]: CustomerFilter,
    [WIDGET.RENEWAL_FILTER_SCREEN_DC]: RenewalFilter,
    [WIDGET.SHORTFALL_FILTER_SCREEN_DC]: ShortfallFilter,
    [WIDGET.CUSTOMER_VIEW_DETAILS_SCREEN_DC]: CustomerViewDetails,
    [WIDGET.CUSTOMER_MOB_DETAILS]: CustomerMobDashboard,
    [WIDGET.PARTNER_REGISTER_LEADS]: PartnerRegisterLeads,
    [WIDGET.PARTNER_LEADS_REGISTRATION_SUCCESS]: PartnerLeadsRegistrationSuccess,
    [WIDGET.PLJ_JOURNEY_PAGE]: PLJJourneyPage,
    [WIDGET.WITHDRAWAL_FAILED_CARD]: WithdrawalFailedCard,
    [WIDGET.VERIFY_AND_INTEREST_SCREEN]: VerifyAndInterest,
    [WIDGET.SDK_PROCESS_COMPLETE_CARD]: SDKProcessCompleteCard,
    [WIDGET.PENDING_APPLICATION_SCREEN]: PendingApplicationScreen,
    [WIDGET.PENDING_MOBILE_APPLICATION_SCREEN]: PendingApplicationMobileScreen,
    [WIDGET.PENDING_CUSTOMER_VIEW_DETAILS_SCREEN_DC]: PendingCustomerViewDetailsScreen,
    [WIDGET.ABOUT_US_SCREEN_DC]: AboutUsScreen,
    [WIDGET.LENDING_PARTNER_SCREEN_DC]: LendingPartnerScreen,
    [WIDGET.PRODUCT_DETAILS_SCREEN_DC]: ProductDetailsScreen,
    [WIDGET.DSP_KFS_PAGE]: DspKfsPage,
    [WIDGET.CONTACT_US_PAGE]: ContactUsPage,
    [WIDGET.REPAYMENT_BANK_TRANSFER]: RepaymentBankTransfer,
    [WIDGET.FAQ_SECTION_PAGE]: FAQSectionPage,
    [WIDGET.ACCOUNT_DETAILS_PAGE]: AccountDetailsPage,
    [WIDGET.UPDATE_DETAILS_SCREEN]: UpdateDetailsScreen,
    [WIDGET.UPDATE_EMAIL_SCREEN]: UpdateEmailScreen,
    [WIDGET.UPDATE_LOGIN_SCREEN]: UpdateLoginScreen,
    [WIDGET.MFC_FETCH_EVALUATE_FUNDS]: MFCentralEvaluateFundsPage,
    [WIDGET.MFC_FETCH_LANDING_PAGE]: MFCentralFetchLandingPage,
    [WIDGET.MFC_FETCH_ANCHOR]: MFCFetchAnchorPage,
    [WIDGET.RECOMMENDED_ASSET_REPOSITORY]: RecommendedAssetRepository,
    [WIDGET.MY_LOAN_PROFILE]: MyLoanProfile,
    [WIDGET.CONFIRM_AND_PAYMENT]: ConfirmAndPayment,
    [WIDGET.FLEXI_REPAY]: FlexiRepayScreen,
    [WIDGET.MFD_SHARE_LINK_INIT_PAGE]: MfdShareLinkInitPage,
    [WIDGET.FORECLOSURE_NEW_SCREEN]: ForeClosureScreen,
    [WIDGET.FORECLOSURE_REASON_SCREEN]: ForeclosureReasonPage,
    [WIDGET.CONFIRM_LOAN_DETAILS]: ConfirmLoanDetails,
    [WIDGET.FORECLOSURE_COLLATERAL_DETAILS]: ForeclosureCollateralDetails,
    [WIDGET.FORECLOSURE_STATUS_PAGE]: ForeclosureStatusPage,
    [WIDGET.BLUR_VIEW_SCREEN]: MyProfile,
    [WIDGET.ELEVATE_LANDING]: ElevateLanding,
    [WIDGET.ELEVATE_HOME_CARD]: ElevateHomeCard,
    [WIDGET.ELEVATE_CONTINUE_CARD]: ElevateContinueCard,
    [WIDGET.ELEVATE_HEADER]: ElevateHeader,
    [WIDGET.ELEVATE_SWITCHING]: ElevateSwitching,
    [WIDGET.HELP_AND_SUPPORT_SCREEN]: HelpAndSupport,
    [WIDGET.FAQ_SCREEN_LMS]: FaqScreen,
    [WIDGET.FAQ_DETAILS_SCREEN]: FaqDetails,
};
export { registry as WidgetRegistry };
